module.exports = __webpack_public_path__ + "static/media/aaa-lc-logowhite.aad4464b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aaa-lc-logowhite.png
// module id = 726
// module chunks = 0